import { useCallback, useEffect } from 'react';

import { useAttachmentsViewerContext } from '../layout/AttachmentsViewer/context';

const useAttachmentsViewerKeyboardNavigation = () => {
  const { viewNextAttachment, viewPreviousAttachment, closeViewer, open } =
    useAttachmentsViewerContext();

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'ArrowRight') {
        viewNextAttachment();
      } else if (event.key === 'ArrowLeft') {
        viewPreviousAttachment();
      } else if (event.key === 'Escape') {
        event.stopPropagation();
        closeViewer();
      }
    },
    [viewNextAttachment, viewPreviousAttachment, closeViewer],
  );

  useEffect(() => {
    if (open) {
      window.addEventListener('keydown', handleKeyDown, { capture: true });
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown, { capture: true });
    };
  }, [handleKeyDown, open]);
};

export default useAttachmentsViewerKeyboardNavigation;
